import React from "react";
import styled from "styled-components";
import { TooltipIcon } from "../icons/TooltipIcon/TooltipIcon";

/**
 * Converte a data final do teste (AAAA-MM-DD) para DD/MM/AAAA. Retorna null quando a data
 * é inválida ou já passou, pois o banner só deve aparecer com o teste vigente.
 */
export const getActiveTrialEndDate = (trialEndDate?: string | null): string | null => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trialEndDate ?? "");

  if (!match) return null;

  const [, year, month, day] = match;
  const endOfTrial = new Date(Number(year), Number(month) - 1, Number(day), 23, 59, 59);

  if (endOfTrial.getTime() < Date.now()) return null;

  return `${day}/${month}/${year}`;
};

interface TrialPeriodBannerProps {
  trialEndDate?: string | null;
}

export const TrialPeriodBanner: React.FC<TrialPeriodBannerProps> = ({ trialEndDate }) => {
  const formattedDate = getActiveTrialEndDate(trialEndDate);

  if (!formattedDate) return null;

  return (
    <BannerContainer role="alert" data-testid="trial-period-banner">
      <IconWrapper>
        <TooltipIcon />
      </IconWrapper>
      <div>
        <BannerTitle>Período de teste</BannerTitle>
        <BannerText>
          Aproveite para testar até <strong>{formattedDate}</strong>. Caso queira continuar utilizando a
          Telemedicina após esse período, o módulo estará disponível para contratação.
        </BannerText>
      </div>
    </BannerContainer>
  );
};

const BannerContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: #fcf3e3;
  color: #c98a1b;
  font-size: 14px;
  line-height: 1.35;
`;

const IconWrapper = styled.div`
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;
  }
`;

const BannerTitle = styled.p`
  margin: 0;
  font-weight: 700;
`;

const BannerText = styled.p`
  margin: 0;
`;
